import { useEffect } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { useMostRecentViewedNoteDate } from './useMostRecentViewedNoteDate';

dayjs.extend(utc);

/**
 * When this hook is called, it will update the date recorded as the most recent note viewing to the current time
 */
export function useUpdateMostRecentViewedNoteDate() {
  const [, setMostRecentViewedNoteDate] = useMostRecentViewedNoteDate();

  useEffect(() => {
    setMostRecentViewedNoteDate(dayjs().utc().toISOString());
  }, [setMostRecentViewedNoteDate]);
}
